import { commonjsGlobal } from "../../../_virtual/_commonjsHelpers.mjs";
import "./index.mjs";
import "./should-polyfill.mjs";
import { __exports as intlDurationformat } from "../../../_virtual/index.mjs";
import { __exports as shouldPolyfill } from "../../../_virtual/should-polyfill.mjs";
var _1 = intlDurationformat;
var should_polyfill_1 = shouldPolyfill;
if (typeof Intl === "undefined") {
  if (typeof window !== "undefined") {
    Object.defineProperty(window, "Intl", {
      value: {}
    });
  } else if (typeof commonjsGlobal !== "undefined") {
    Object.defineProperty(commonjsGlobal, "Intl", {
      value: {}
    });
  }
}
if ((0, should_polyfill_1.shouldPolyfill)()) {
  Object.defineProperty(Intl, "DurationFormat", {
    value: _1.DurationFormat
  });
}
const polyfill = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
export {
  polyfill as p
};
